import { INetworkResult } from '@/coreDomainsModule/networkResult';
import { IError } from '@/coreInfrastructureModule/interfaces/IError';
import { IUnmatchedOrderRepository } from '@/coreInfrastructureModule/interfaces/IUnmatchedOrderRepository';
import { RegisterUnmatchedOrderBusinessRequest } from '@/coreInfrastructureModule/axios/generated/unmatchedOrderManage';
import { OrderBusinessForRegister } from '../domains/entities/UnmatchedOrderItem';
import { RegisterUnmatchedOrderBusinessAdapter } from '../adapters/registerUnmatchedOrderBusinessAdapter';

/**
 * 未照合・差異一覧情報を更新するユースケース
 */
export class RegisterUnmatchedOrderBusinessUseCase {
  private repository: IUnmatchedOrderRepository;

  /**
   * コンストラクタ
   * @param repository - リポジトリ
   */
  constructor(repository: IUnmatchedOrderRepository) {
    this.repository = repository;
  }

  /**
   * 未照合の発注取引を登録する
   * @param request - 登録情報リスト
   * @returns 更新されたID一覧
   */
  public async execute(request: OrderBusinessForRegister): Promise<INetworkResult<void, IError>> {
    const adaptedRequest: RegisterUnmatchedOrderBusinessRequest = RegisterUnmatchedOrderBusinessAdapter.adapt(request);
    const networkResult = await this.repository.register(adaptedRequest);
    switch (networkResult.status.type) {
      case 'success':
        return {
          status: {
            type: 'success',
            data: undefined,
          },
        };
      case 'error':
      default:
        return { status: { type: 'error', error: networkResult.status.error } };
    }
  }
}
